(function () {
    'use strict';
    angular.module('app').directive('selectioncommandreleasecheckout', selectioncommand_releasecheckout);
    function selectioncommand_releasecheckout() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                releaseCheckOutDialogShown: '=?'
            },
            controller: 'releasecheckout',
            templateUrl: 'app/selectioncommand/selectioncommand_releasecheckout.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();